import {store} from "../helper/store";
import {updateServices} from "../redux_actions/morpheus.setting.action";
import {notNull} from "./utils";

export const checkServicePermission = service => {
	// @Spandan code is deprecated, but keeping it alive, if anyone needs to revive it.
	// let {services} = store.getState().morpheusSettingReducer;
	// if (services[service.service] === undefined) {
	// 	services[service.service] = service.defaultPermission || false;
	// 	store.dispatch(updateServices(services));
	// }
	// service.permission = services[service.service];
	// return service.permission;
	return false;
}
